// Réglages du fond animé. Modifier puis recharger la page (ou relancer le build).
var $ef0d475ec54ccfb2$export$2e2bcd8739ae039 = {
    dots: {
        count: 3000,
        strands: 30,
        size: 1,
        opacity: 1 // Multiplicateur de luminosité, de 0 à 1.
    },
    colors: {
        // Couleurs RGB des particules : on peut ajouter ou retirer des couleurs.
        palette: [
            '60, 95, 255',
            '25, 175, 255',
            '20, 245, 212',
            '95, 255, 100'
        ],
        stars: '90, 170, 255',
        cycleSpeed: .35,
        // Décalage de teinte en degrés pour chaque page.
        sectionHue: {
            hero: 0,
            works: 0,
            references: 100,
            contributions: 210
        },
        transitionSeconds: 1.6
    },
    animation: {
        speed: 1,
        rotationSpeed: .09,
        sphereHold: 7,
        morphDuration: 5,
        torusHold: 8,
        sphereRest: 1
    },
    shape: {
        width: .48,
        height: .47,
        centerY: .48,
        tilt: .85,
        ripple: .095,
        fold: .045,
        twist: .18
    },
    mouse: {
        horizontal: 1.8,
        vertical: 1.4,
        easing: .035 // Entre 0 et 1 : plus élevé = réaction plus immédiate.
    },
    stars: {
        count: 110
    },
    glow: {
        enabled: true,
        intensity: 1,
        bokeh: true // Halos flous sur certains points au premier plan.
    },
    performance: {
        fps: 30,
        pixelRatio: 1.5 // Limite de résolution sur les écrans Retina.
    }
};


const $e8cd3226f3ec99da$var$canvas = document.getElementById('network');
const $e8cd3226f3ec99da$var$ctx = $e8cd3226f3ec99da$var$canvas?.getContext('2d');
if ($e8cd3226f3ec99da$var$ctx) {
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const pointer = {
        x: 0,
        y: 0
    };
    const offset = {
        x: 0,
        y: 0
    };
    const particles = [];
    const palette = (0, $ef0d475ec54ccfb2$export$2e2bcd8739ae039).colors.palette;
    const rootStyle = document.documentElement.style;
    for (const [section, hue] of Object.entries((0, $ef0d475ec54ccfb2$export$2e2bcd8739ae039).colors.sectionHue))rootStyle.setProperty(`--network-hue-${section}`, `${hue}deg`);
    rootStyle.setProperty('--network-color-duration', `${(0, $ef0d475ec54ccfb2$export$2e2bcd8739ae039).colors.transitionSeconds}s`);
    const buckets = Array.from({
        length: palette.length * 16
    }, ()=>[]);
    const glow = document.createElement('canvas');
    const glowCtx = glow.getContext('2d');
    const stars = [];
    const sprites = palette.map((color)=>{
        const sprite = document.createElement('canvas');
        const context = sprite.getContext('2d');
        sprite.width = 64;
        sprite.height = 64;
        const gradient = context.createRadialGradient(32, 32, 0, 32, 32, 32);
        gradient.addColorStop(0, `rgba(${color}, .6)`);
        gradient.addColorStop(.15, `rgba(${color}, .25)`);
        gradient.addColorStop(.45, `rgba(${color}, .07)`);
        gradient.addColorStop(1, `rgba(${color}, 0)`);
        context.fillStyle = gradient;
        context.fillRect(0, 0, 64, 64);
        return sprite;
    });
    // Ordered strands, rather than random dots, reveal the flowing surface.
    const dotCount = Math.max(0, Math.floor((0, $ef0d475ec54ccfb2$export$2e2bcd8739ae039).dots.count));
    const strands = Math.max(1, Math.min(dotCount, Math.floor((0, $ef0d475ec54ccfb2$export$2e2bcd8739ae039).dots.strands)));
    for(let strand = 0; strand < strands; strand++){
        const steps = Math.floor(dotCount / strands) + Number(strand < dotCount % strands);
        for(let step = 0; step < steps; step++){
            const u = strand / strands * Math.PI * 2;
            const v = (step + .5) / steps * Math.PI;
            particles.push({
                u: u,
                v: v,
                strand: strand,
                step: step
            });
        }
    }
    for(let i = 0; i < (0, $ef0d475ec54ccfb2$export$2e2bcd8739ae039).stars.count; i++)stars.push({
        x: Math.sin(i * 127.1) * .5 + .5,
        y: Math.sin(i * 311.7) * .5 + .5,
        size: .4 + i % 5 * .3
    });
    let width = 0;
    let height = 0;
    let frame = 0;
    let lastTime = 0;
    let time = 0;
    function draw() {
        $e8cd3226f3ec99da$var$ctx.clearRect(0, 0, width, height);
        // Hold each silhouette, then ease into the next.
        const { sphereHold: sphereHold, torusHold: torusHold, sphereRest: sphereRest } = (0, $ef0d475ec54ccfb2$export$2e2bcd8739ae039).animation;
        const duration = Math.max(.001, (0, $ef0d475ec54ccfb2$export$2e2bcd8739ae039).animation.morphDuration);
        const returnStart = sphereHold + duration + torusHold;
        const cycle = time % (returnStart + duration + sphereRest);
        const transition = Math.max(0, Math.min(1, (cycle - sphereHold) / duration));
        const returning = Math.max(0, Math.min(1, (cycle - returnStart) / duration));
        const morph = transition * transition * (3 - 2 * transition) - returning * returning * (3 - 2 * returning);
        const yaw = time * (0, $ef0d475ec54ccfb2$export$2e2bcd8739ae039).animation.rotationSpeed + offset.x;
        const pitch = (0, $ef0d475ec54ccfb2$export$2e2bcd8739ae039).shape.tilt + offset.y + Math.sin(time * .13) * .16;
        const roll = .15 + Math.sin(time * .08) * .12;
        const cy = Math.cos(yaw);
        const sy = Math.sin(yaw);
        const cx = Math.cos(pitch);
        const sx = Math.sin(pitch);
        const cr = Math.cos(roll);
        const sr = Math.sin(roll);
        const scale = Math.min(width * (0, $ef0d475ec54ccfb2$export$2e2bcd8739ae039).shape.width, height * (0, $ef0d475ec54ccfb2$export$2e2bcd8739ae039).shape.height);
        for (const bucket of buckets)bucket.length = 0;
        glowCtx.clearRect(0, 0, glow.width, glow.height);
        for(let i = 0; i < stars.length; i++){
            const star = stars[i];
            const x = star.x * width + offset.x * (i % 12);
            const y = star.y * height + offset.y * (i % 12);
            $e8cd3226f3ec99da$var$ctx.fillStyle = `rgba(${(0, $ef0d475ec54ccfb2$export$2e2bcd8739ae039).colors.stars}, ${.15 + .1 * Math.sin(time * .4 + i)})`;
            $e8cd3226f3ec99da$var$ctx.beginPath();
            $e8cd3226f3ec99da$var$ctx.arc(x, y, star.size, 0, Math.PI * 2);
            $e8cd3226f3ec99da$var$ctx.fill();
        }
        for (const particle of particles){
            const { u: u, v: v, strand: strand, step: step } = particle;
            const ripple = Math.sin(u * 5 + v * 4 + time * .65);
            const fold = Math.sin(v * 7 - u * 3 - time * .4);
            const radius = 1 + ripple * (0, $ef0d475ec54ccfb2$export$2e2bcd8739ae039).shape.ripple + fold * (0, $ef0d475ec54ccfb2$export$2e2bcd8739ae039).shape.fold;
            const twist = u + (0, $ef0d475ec54ccfb2$export$2e2bcd8739ae039).shape.twist * Math.sin(v * 4 + time * .3);
            const sphereX = Math.sin(v) * Math.cos(twist) * radius;
            const sphereY = Math.cos(v) * radius;
            const sphereZ = Math.sin(v) * Math.sin(twist) * radius;
            const tube = v * 2;
            const ring = .7 + (.28 + ripple * .045) * Math.cos(tube);
            const torusX = ring * Math.cos(twist);
            const torusY = .28 * Math.sin(tube) + fold * (0, $ef0d475ec54ccfb2$export$2e2bcd8739ae039).shape.fold;
            const torusZ = ring * Math.sin(twist);
            const x = sphereX + (torusX - sphereX) * morph;
            const y = sphereY + (torusY - sphereY) * morph;
            const z = sphereZ + (torusZ - sphereZ) * morph;
            const rotatedX = x * cy + z * sy;
            const rotatedZ = z * cy - x * sy;
            const rotatedY = y * cx - rotatedZ * sx;
            const depth = y * sx + rotatedZ * cx;
            const perspective = 3.5 / (3.5 - depth);
            const screenX = width * .5 + (rotatedX * cr - rotatedY * sr) * scale * perspective;
            const screenY = height * (0, $ef0d475ec54ccfb2$export$2e2bcd8739ae039).shape.centerY + (rotatedX * sr + rotatedY * cr) * scale * perspective;
            const depthIndex = Math.max(0, Math.min(15, Math.floor((depth + 1.2) * 6.25)));
            const colorWave = Math.sin(u * 3 + v * 5 + time * (0, $ef0d475ec54ccfb2$export$2e2bcd8739ae039).colors.cycleSpeed);
            const color = Math.max(0, Math.min(palette.length - 1, Math.floor((colorWave + 1) * palette.length / 2)));
            buckets[color * 16 + depthIndex].push(screenX, screenY);
            // Low-resolution bloom and occasional defocused foreground beads.
            if ((0, $ef0d475ec54ccfb2$export$2e2bcd8739ae039).glow.enabled && step % 6 === 0 && strand % 2 === 0) {
                const size = (12 + depthIndex * 1.8) * Math.max(.65, scale / 500);
                glowCtx.drawImage(sprites[color], (screenX - size) / 3, (screenY - size) / 3, size * 2 / 3, size * 2 / 3);
            }
            if ((0, $ef0d475ec54ccfb2$export$2e2bcd8739ae039).glow.bokeh && depth > .65 && strand % 9 === 0 && step % 7 === 0) {
                const size = 5 + (depth - .65) * 22;
                $e8cd3226f3ec99da$var$ctx.drawImage(sprites[color], screenX - size, screenY - size, size * 2, size * 2);
            }
        }
        $e8cd3226f3ec99da$var$ctx.globalCompositeOperation = 'lighter';
        $e8cd3226f3ec99da$var$ctx.globalAlpha = (0, $ef0d475ec54ccfb2$export$2e2bcd8739ae039).glow.intensity;
        $e8cd3226f3ec99da$var$ctx.drawImage(glow, 0, 0, width, height);
        $e8cd3226f3ec99da$var$ctx.globalAlpha = 1;
        for(let i = 0; i < buckets.length; i++){
            const bucket = buckets[i];
            const depth = i % 16;
            const color = Math.floor(i / 16);
            const radius = (0, $ef0d475ec54ccfb2$export$2e2bcd8739ae039).dots.size * (.45 + depth * .075) * Math.max(.7, Math.min(1.2, scale / 450));
            $e8cd3226f3ec99da$var$ctx.fillStyle = `rgba(${palette[color]}, ${(.13 + depth * .042) * (0, $ef0d475ec54ccfb2$export$2e2bcd8739ae039).dots.opacity})`;
            $e8cd3226f3ec99da$var$ctx.beginPath();
            for(let j = 0; j < bucket.length; j += 2){
                $e8cd3226f3ec99da$var$ctx.moveTo(bucket[j] + radius, bucket[j + 1]);
                $e8cd3226f3ec99da$var$ctx.arc(bucket[j], bucket[j + 1], radius, 0, Math.PI * 2);
            }
            $e8cd3226f3ec99da$var$ctx.fill();
        }
        $e8cd3226f3ec99da$var$ctx.globalCompositeOperation = 'source-over';
    }
    function animate(now) {
        if (now - lastTime >= 1000 / (0, $ef0d475ec54ccfb2$export$2e2bcd8739ae039).performance.fps) {
            time += Math.min((now - lastTime) / 1000, .1) * (0, $ef0d475ec54ccfb2$export$2e2bcd8739ae039).animation.speed;
            lastTime = now;
            offset.x += (pointer.x - offset.x) * (0, $ef0d475ec54ccfb2$export$2e2bcd8739ae039).mouse.easing;
            offset.y += (pointer.y - offset.y) * (0, $ef0d475ec54ccfb2$export$2e2bcd8739ae039).mouse.easing;
            draw();
        }
        frame = requestAnimationFrame(animate);
    }
    function refresh() {
        cancelAnimationFrame(frame);
        if (motion.matches) {
            offset.x = 0;
            offset.y = 0;
        }
        draw();
        if (!motion.matches && !document.hidden) {
            lastTime = performance.now();
            frame = requestAnimationFrame(animate);
        }
    }
    function resize() {
        width = window.innerWidth;
        height = window.innerHeight;
        const ratio = Math.min(window.devicePixelRatio || 1, (0, $ef0d475ec54ccfb2$export$2e2bcd8739ae039).performance.pixelRatio);
        $e8cd3226f3ec99da$var$canvas.width = Math.round(width * ratio);
        $e8cd3226f3ec99da$var$canvas.height = Math.round(height * ratio);
        glow.width = Math.ceil(width / 3);
        glow.height = Math.ceil(height / 3);
        $e8cd3226f3ec99da$var$ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
        refresh();
    }
    window.addEventListener('pointermove', (event)=>{
        if (event.pointerType === 'mouse' && !motion.matches) {
            pointer.x = (event.clientX / width - .5) * (0, $ef0d475ec54ccfb2$export$2e2bcd8739ae039).mouse.horizontal;
            pointer.y = (event.clientY / height - .5) * (0, $ef0d475ec54ccfb2$export$2e2bcd8739ae039).mouse.vertical;
        }
    }, {
        passive: true
    });
    document.addEventListener('pointerleave', ()=>{
        pointer.x = 0;
        pointer.y = 0;
    });
    window.addEventListener('resize', resize);
    document.addEventListener('visibilitychange', refresh);
    motion.addEventListener('change', refresh);
    resize();
}


console.log("%c\uD83D\uDE01 ", 'font-size: 48px;');
console.log('%cCurious? ', 'font-size: 24px; font-weight: bold; color: "purple";');
console.log('%cNeed a frontend developer?', 'font-size: 16px; font-weight: bold;');
console.log("%cYou\u2018re in the right place!", 'font-size: 16px; font-weight: bold;');
// ─── Lang query param ────────────────────────────────────────────────────────
const $388b617130f03bd4$var$params = new URLSearchParams(location.search);
const $388b617130f03bd4$var$lang = $388b617130f03bd4$var$params.get('lang');
if ($388b617130f03bd4$var$lang) {
    localStorage.setItem('lang', $388b617130f03bd4$var$lang);
    document.documentElement.lang = $388b617130f03bd4$var$lang;
    document.documentElement.className = document.documentElement.className.replace(/\blang-\w+/g, '') + ' lang-' + $388b617130f03bd4$var$lang;
}
function $388b617130f03bd4$var$$qa(selector, parent = document) {
    return Array.from(parent.querySelectorAll(selector));
}
function $388b617130f03bd4$var$$q(selector, parent = document) {
    return parent.querySelector(selector);
}
function $388b617130f03bd4$var$addClass(element, className) {
    if (element) element.classList.add(className);
}
function $388b617130f03bd4$var$removeClass(element, className) {
    if (element) element.classList.remove(className);
}
function $388b617130f03bd4$var$containsClass(element, className) {
    if (element) return element.classList.contains(className);
    return false;
}
$388b617130f03bd4$var$$qa('.reference').forEach(($el, i)=>{
    $el.style.transitionDelay = i * 0.1 + 's';
});
$388b617130f03bd4$var$$qa('.awards-container p span').forEach(($el, i)=>{
    $el.style.transitionDelay = i * 0.1 + 's';
});
$388b617130f03bd4$var$$qa('.clients-container img').forEach(($el, i)=>{
    $el.style.transitionDelay = 3.5 + i * 0.1 + 's';
});
// ─────────────────────────────────────────────────────────────────────────────
const $388b617130f03bd4$var$isMobile = ()=>/(Android|webOS|Phone|iPad|iPod|BlackBerry|Windows Phone)/i.test(navigator.userAgent);
const $388b617130f03bd4$var$debounce = (fn, delay)=>{
    let last;
    let timer;
    return function(...args) {
        const now = Date.now();
        if (last && now < last + delay) {
            clearTimeout(timer);
            timer = setTimeout(()=>{
                last = now;
                fn(...args);
            }, delay);
            return timer;
        } else {
            last = now;
            return fn(...args);
        }
    };
};
document.addEventListener('DOMContentLoaded', ()=>{
    const slideContainer = $388b617130f03bd4$var$$q('.slide-container');
    const pageContainer = $388b617130f03bd4$var$$q('.work-container');
    const pageNavigation = $388b617130f03bd4$var$$q('.work-pagination');
    const totalWorks = $388b617130f03bd4$var$$qa('.work').length;
    const references = $388b617130f03bd4$var$$q('.references');
    const referencesWrapper = $388b617130f03bd4$var$$q('.references-wrapper');
    const referenceNavigation = $388b617130f03bd4$var$$q('.reference-pagination');
    const referenceCards = $388b617130f03bd4$var$$qa('.reference', referencesWrapper || document);
    const animationEnd = 'animationend';
    const angle = {
        cube: 0
    };
    const face = {
        cube: 0
    };
    let totalPages = totalWorks;
    let page = 1;
    let totalReferencePages = referenceCards.length;
    let referencePage = 1;
    // ─── Cube 3D ────────────────────────────────────────────────────────────
    const rotateCube = (type)=>{
        angle[type] += 90;
        face[type] += 1;
        if (face[type] >= 4) face[type] = 0;
        const cubeFaces = $388b617130f03bd4$var$$qa('.' + type + ' div');
        cubeFaces.forEach((faceElement)=>{
            $388b617130f03bd4$var$removeClass(faceElement, 'active');
        });
        if (cubeFaces[face[type]]) $388b617130f03bd4$var$addClass(cubeFaces[face[type]], 'active');
        const cube = $388b617130f03bd4$var$$q('.' + type);
        if (cube) cube.style.transform = 'rotateX(' + angle[type] + 'deg)';
        setTimeout(()=>{
            rotateCube(type);
        }, Math.random() * 1000 + 1000);
    };
    rotateCube('cube');
    if (references && referencesWrapper && !$388b617130f03bd4$var$isMobile()) {
        let tiltFrame = null;
        let isOverReferencesLink = false;
        let targetRotateX = 0;
        let targetRotateY = 0;
        let currentRotateX = 0;
        let currentRotateY = 0;
        const renderTilt = ()=>{
            currentRotateX += (targetRotateX - currentRotateX) * 0.12;
            currentRotateY += (targetRotateY - currentRotateY) * 0.12;
            referencesWrapper.style.setProperty('--tilt-x', currentRotateX.toFixed(2) + 'deg');
            referencesWrapper.style.setProperty('--tilt-y', currentRotateY.toFixed(2) + 'deg');
            const stillAnimating = Math.abs(targetRotateX - currentRotateX) > 0.01 || Math.abs(targetRotateY - currentRotateY) > 0.01;
            if (stillAnimating) tiltFrame = requestAnimationFrame(renderTilt);
            else tiltFrame = null;
        };
        const queueTiltRender = ()=>{
            if (!tiltFrame) tiltFrame = requestAnimationFrame(renderTilt);
        };
        const resetTiltImmediately = ()=>{
            targetRotateX = 0;
            targetRotateY = 0;
            currentRotateX = 0;
            currentRotateY = 0;
            if (tiltFrame) {
                cancelAnimationFrame(tiltFrame);
                tiltFrame = null;
            }
            referencesWrapper.style.setProperty('--tilt-x', '0deg');
            referencesWrapper.style.setProperty('--tilt-y', '0deg');
        };
        references.addEventListener('mouseover', (event)=>{
            const link = event.target.closest('a');
            if (!link) return;
            isOverReferencesLink = true;
            resetTiltImmediately();
        });
        references.addEventListener('mouseout', (event)=>{
            const link = event.target.closest('a');
            if (!link) return;
            const to = event.relatedTarget;
            if (to && link.contains(to)) return;
            isOverReferencesLink = false;
        });
        references.addEventListener('mousemove', (event)=>{
            if (isOverReferencesLink || event.target.closest('a')) {
                resetTiltImmediately();
                return;
            }
            const rect = references.getBoundingClientRect();
            const x = (event.clientX - rect.left) / rect.width;
            const y = (event.clientY - rect.top) / rect.height;
            const rotateY = (x - 0.5) * 3;
            const rotateX = (0.5 - y) * 2.25;
            targetRotateX = rotateX;
            targetRotateY = rotateY;
            queueTiltRender();
        });
        references.addEventListener('mouseleave', ()=>{
            targetRotateX = 0;
            targetRotateY = 0;
            queueTiltRender();
        });
    }
    // ─── Scroll vers un slide (1-based) ────────────────────────────────────
    const scrollToSlide = (idx)=>{
        if (!slideContainer) return;
        slideContainer.scrollTo({
            top: (idx - 1) * window.innerHeight,
            behavior: 'smooth'
        });
    };
    // ─── Détection du slide visible ─────────────────────────────────────────
    let swipeTimer;
    let swipeTimer2;
    let hint1shown = false;
    let hint2shown = false;
    const slideObserver = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting && entry.intersectionRatio >= .6) document.documentElement.dataset.backgroundSection = entry.target.id;
            if ($388b617130f03bd4$var$containsClass(entry.target, 'works')) {
                if (entry.isIntersecting) $388b617130f03bd4$var$addClass(document.documentElement, 'works-visible');
                else $388b617130f03bd4$var$removeClass(document.documentElement, 'works-visible');
            }
            if ($388b617130f03bd4$var$containsClass(entry.target, 'references')) {
                if (entry.isIntersecting) $388b617130f03bd4$var$addClass(document.documentElement, 'references-visible');
                else $388b617130f03bd4$var$removeClass(document.documentElement, 'references-visible');
            }
            if (entry.isIntersecting) {
                if ($388b617130f03bd4$var$containsClass(entry.target, 'contributions')) $388b617130f03bd4$var$addClass(entry.target, 'animated');
                if ($388b617130f03bd4$var$containsClass(entry.target, 'references')) $388b617130f03bd4$var$addClass(entry.target, 'animated');
                if ($388b617130f03bd4$var$containsClass(entry.target, 'hero') && !hint1shown) {
                    hint1shown = true;
                    swipeTimer = setTimeout(()=>{
                        $388b617130f03bd4$var$$qa('.touch .slide-swipe').forEach((element)=>{
                            $388b617130f03bd4$var$addClass(element, 'vertical');
                        });
                        $388b617130f03bd4$var$$qa('.slide-swipe .icon').forEach((icon)=>{
                            icon.addEventListener(animationEnd, ()=>{
                                $388b617130f03bd4$var$$qa('.slide-swipe').forEach((element)=>{
                                    $388b617130f03bd4$var$removeClass(element, 'vertical');
                                });
                            }, {
                                once: true
                            });
                        });
                    }, 4000);
                }
                if ($388b617130f03bd4$var$containsClass(entry.target, 'works') && !hint2shown) {
                    hint2shown = true;
                    swipeTimer2 = setTimeout(()=>{
                        $388b617130f03bd4$var$$qa('.touch .slide-swipe').forEach((element)=>{
                            $388b617130f03bd4$var$addClass(element, 'horizontal');
                        });
                        $388b617130f03bd4$var$$qa('.slide-swipe .icon').forEach((icon)=>{
                            icon.addEventListener(animationEnd, ()=>{
                                $388b617130f03bd4$var$$qa('.slide-swipe').forEach((element)=>{
                                    $388b617130f03bd4$var$removeClass(element, 'horizontal');
                                });
                            }, {
                                once: true
                            });
                        });
                    }, 600);
                }
            } else {
                if ($388b617130f03bd4$var$containsClass(entry.target, 'hero')) {
                    clearTimeout(swipeTimer);
                    $388b617130f03bd4$var$$qa('.slide-swipe').forEach((element)=>{
                        $388b617130f03bd4$var$removeClass(element, 'vertical');
                    });
                }
                if ($388b617130f03bd4$var$containsClass(entry.target, 'works')) {
                    clearTimeout(swipeTimer2);
                    $388b617130f03bd4$var$$qa('.slide-swipe').forEach((element)=>{
                        $388b617130f03bd4$var$removeClass(element, 'horizontal');
                    });
                }
            }
        });
    }, {
        root: slideContainer,
        threshold: 0.6
    });
    $388b617130f03bd4$var$$qa('.slide').forEach((slide)=>{
        slideObserver.observe(slide);
    });
    // ─── Navigation Works (horizontal) ─────────────────────────────────────
    const gotoPage = (idx)=>{
        page = idx;
        const firstWork = $388b617130f03bd4$var$$q('.work');
        if (!firstWork || !pageContainer) return;
        const width = firstWork.offsetWidth;
        pageContainer.scrollTo({
            left: (page - 1) * width,
            behavior: 'smooth'
        });
        const works = $388b617130f03bd4$var$$qa('.work', pageContainer);
        works.forEach((work)=>{
            $388b617130f03bd4$var$removeClass(work, 'active');
        });
        if (works[page - 1]) $388b617130f03bd4$var$addClass(works[page - 1], 'active');
        updatePageNavigation();
    };
    const nextPage = ()=>{
        if (page >= totalPages) return;
        page += 1;
        gotoPage(page);
    };
    const previousPage = ()=>{
        if (page <= 1) return;
        page -= 1;
        gotoPage(page);
    };
    const changePage = (e)=>{
        if (e.keyCode === 37) {
            e.preventDefault();
            previousPage();
        }
        if (e.keyCode === 39) {
            e.preventDefault();
            nextPage();
        }
    };
    if (pageContainer) pageContainer.addEventListener('scrollend', ()=>{
        const firstWork = $388b617130f03bd4$var$$q('.work', pageContainer);
        if (!firstWork) return;
        const workWidth = firstWork.offsetWidth;
        const newPage = Math.round(pageContainer.scrollLeft / workWidth) + 1;
        const works = $388b617130f03bd4$var$$qa('.work', pageContainer);
        page = Math.max(1, Math.min(newPage, totalPages));
        works.forEach((work)=>{
            $388b617130f03bd4$var$removeClass(work, 'active');
        });
        if (works[page - 1]) $388b617130f03bd4$var$addClass(works[page - 1], 'active');
        updatePageNavigation();
    });
    const updatePageNavigation = ()=>{
        if (!pageNavigation) return;
        const paginationLinks = $388b617130f03bd4$var$$qa('a', pageNavigation);
        const previousButton = $388b617130f03bd4$var$$q('.work-previous');
        const nextButton = $388b617130f03bd4$var$$q('.work-next');
        paginationLinks.forEach((link)=>{
            $388b617130f03bd4$var$removeClass(link, 'active');
        });
        if (paginationLinks[page - 1]) $388b617130f03bd4$var$addClass(paginationLinks[page - 1], 'active');
        if (previousButton) {
            $388b617130f03bd4$var$removeClass(previousButton, 'disabled');
            if (page === 1) $388b617130f03bd4$var$addClass(previousButton, 'disabled');
        }
        if (nextButton) {
            $388b617130f03bd4$var$removeClass(nextButton, 'disabled');
            if (page === totalPages) $388b617130f03bd4$var$addClass(nextButton, 'disabled');
        }
    };
    const isReferencesMobileSnap = ()=>window.matchMedia('(max-width: 1000px)').matches;
    const updateReferenceNavigation = ()=>{
        if (!referenceNavigation || !isReferencesMobileSnap()) return;
        const paginationLinks = $388b617130f03bd4$var$$qa('a', referenceNavigation);
        paginationLinks.forEach((link)=>{
            $388b617130f03bd4$var$removeClass(link, 'active');
        });
        if (paginationLinks[referencePage - 1]) $388b617130f03bd4$var$addClass(paginationLinks[referencePage - 1], 'active');
    };
    const getReferencePageFromScroll = ()=>{
        if (!referencesWrapper || referenceCards.length === 0) return 1;
        const currentLeft = referencesWrapper.scrollLeft;
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;
        referenceCards.forEach((card, index)=>{
            const distance = Math.abs(card.offsetLeft - currentLeft);
            if (distance < closestDistance) {
                closestDistance = distance;
                closestIndex = index;
            }
        });
        return closestIndex + 1;
    };
    const gotoReferencePage = (idx)=>{
        referencePage = idx;
        if (!referencesWrapper || !referenceCards[referencePage - 1]) return;
        referencesWrapper.scrollTo({
            left: referenceCards[referencePage - 1].offsetLeft,
            behavior: 'smooth'
        });
        updateReferenceNavigation();
    };
    const initReferencesPagination = ()=>{
        if (!referenceNavigation) return;
        referenceNavigation.innerHTML = '';
        totalReferencePages = referenceCards.length;
        referencePage = Math.max(1, Math.min(referencePage, totalReferencePages || 1));
        if (!isReferencesMobileSnap() || totalReferencePages <= 1) return;
        for(let x = 0; x < totalReferencePages; x += 1){
            const link = document.createElement('a');
            link.href = '#';
            link.addEventListener('click', (e)=>{
                const links = $388b617130f03bd4$var$$qa('a', referenceNavigation);
                e.preventDefault();
                gotoReferencePage(Array.from(links).indexOf(e.currentTarget) + 1);
            });
            referenceNavigation.appendChild(link);
        }
        referencePage = getReferencePageFromScroll();
        updateReferenceNavigation();
    };
    const orientation = ()=>{
        const orientationAngle = screen.orientation ? screen.orientation.angle : 0;
        const swipeHints = $388b617130f03bd4$var$$qa('.touch .slide-swipe');
        if ($388b617130f03bd4$var$isMobile() && orientationAngle % 180 !== 0) swipeHints.forEach((element)=>{
            $388b617130f03bd4$var$addClass(element, 'orientation');
        });
        else swipeHints.forEach((element)=>{
            $388b617130f03bd4$var$removeClass(element, 'orientation');
        });
    };
    const initWorks = ()=>{
        const workElement = $388b617130f03bd4$var$$q('.work');
        updatePageNavigation();
        if (!workElement || !pageNavigation) {
            totalPages = 0;
            return;
        }
        const workWidth = workElement.getBoundingClientRect().width;
        const containerWidth = pageContainer ? pageContainer.clientWidth : window.innerWidth;
        const worksPerPage = Math.max(1, Math.floor(containerWidth / workWidth));
        totalPages = Math.ceil(totalWorks / worksPerPage);
        pageNavigation.innerHTML = '';
        if (totalPages <= 1) return;
        for(let x = 0; x < totalPages; x += 1){
            const link = document.createElement('a');
            link.href = '#';
            link.addEventListener('click', (e)=>{
                const links = $388b617130f03bd4$var$$qa('a', pageNavigation);
                e.preventDefault();
                gotoPage(Array.from(links).indexOf(e.currentTarget) + 1);
            });
            pageNavigation.appendChild(link);
        }
        updatePageNavigation();
        if (page > totalPages) {
            page = totalPages;
            gotoPage(page);
        }
    };
    // ─── Init ────────────────────────────────────────────────────────────────
    initWorks();
    gotoPage(page);
    initReferencesPagination();
    if ('ontouchstart' in window || 'onmsgesturechange' in window) document.documentElement.classList.add('touch');
    else document.documentElement.classList.add('no-touch');
    const wrapTextNodes = (root)=>{
        Array.from(root.childNodes).forEach((node)=>{
            if (node.nodeType === 3) {
                const wrapper = document.createElement('span');
                node.parentNode.insertBefore(wrapper, node);
                wrapper.appendChild(node);
            }
        });
    };
    $388b617130f03bd4$var$$qa('.hero-bio p').forEach((paragraph)=>{
        wrapTextNodes(paragraph);
    });
    const contributionsParagraph = $388b617130f03bd4$var$$q('.contributions p');
    if (contributionsParagraph) wrapTextNodes(contributionsParagraph);
    $388b617130f03bd4$var$$qa('.lang-btn').forEach((button)=>{
        button.addEventListener('click', (e)=>{
            e.preventDefault();
            const selectedLang = e.currentTarget.getAttribute('data-lang');
            document.documentElement.lang = selectedLang;
            document.documentElement.className = document.documentElement.className.replace(/\blang-\w+/g, '') + ' lang-' + selectedLang;
            localStorage.setItem('lang', selectedLang);
            const url = new URL(location.href);
            url.searchParams.set('lang', selectedLang);
            history.replaceState(null, '', url);
            $388b617130f03bd4$var$restartBubble(selectedLang);
        });
    });
    $388b617130f03bd4$var$$qa('.social-email a').forEach((link)=>{
        link.setAttribute('href', 'mailto:' + link.getAttribute('href').replace('#', '@').replace('|', '.'));
    });
    $388b617130f03bd4$var$$qa('.hero-scroll').forEach((button)=>{
        button.addEventListener('click', (e)=>{
            e.preventDefault();
            scrollToSlide(2);
        });
    });
    $388b617130f03bd4$var$$qa('.work-previous').forEach((button)=>{
        button.addEventListener('click', (e)=>{
            previousPage();
            e.preventDefault();
        });
    });
    $388b617130f03bd4$var$$qa('.work-next').forEach((button)=>{
        button.addEventListener('click', (e)=>{
            nextPage();
            e.preventDefault();
        });
    });
    if (referencesWrapper) {
        const syncReferencePagination = $388b617130f03bd4$var$debounce(()=>{
            if (!isReferencesMobileSnap() || totalReferencePages <= 1) return;
            referencePage = getReferencePageFromScroll();
            updateReferenceNavigation();
        }, 50);
        referencesWrapper.addEventListener('scroll', syncReferencePagination);
        referencesWrapper.addEventListener('scrollend', syncReferencePagination);
    }
    setTimeout(()=>{
        $388b617130f03bd4$var$$qa('.hero').forEach((hero)=>{
            hero.classList.add('animated');
        });
    }, 500);
    window.addEventListener('keydown', $388b617130f03bd4$var$debounce(changePage, 50));
    window.addEventListener('resize', $388b617130f03bd4$var$debounce(()=>{
        initWorks();
        initReferencesPagination();
    }, 250));
    window.addEventListener('orientationchange', orientation);
    window.dispatchEvent(new Event('orientationchange'));
});
// ─── Typing FX ───────────────────────────────────────────────────────────────
const $388b617130f03bd4$var$container = document.querySelector('.bubble-text');
const $388b617130f03bd4$var$sentences = [];
const $388b617130f03bd4$var$allSentences = [];
let $388b617130f03bd4$var$typingGen = 0;
$388b617130f03bd4$var$$qa('.bubble-text p').forEach((item)=>{
    $388b617130f03bd4$var$allSentences.push({
        text: item.innerHTML,
        wait: item.dataset.wait,
        back: item.dataset.back,
        lang: item.getAttribute('lang')
    });
});
const $388b617130f03bd4$var$collectSentences = (activeLang)=>{
    $388b617130f03bd4$var$sentences.length = 0;
    $388b617130f03bd4$var$allSentences.forEach((sentence)=>{
        if (!sentence.lang || sentence.lang === activeLang) $388b617130f03bd4$var$sentences.push(sentence);
    });
};
const $388b617130f03bd4$var$restartBubble = (activeLang)=>{
    $388b617130f03bd4$var$typingGen += 1;
    const gen = $388b617130f03bd4$var$typingGen;
    $388b617130f03bd4$var$collectSentences(activeLang);
    if (!$388b617130f03bd4$var$container) return;
    $388b617130f03bd4$var$container.innerHTML = '';
    $388b617130f03bd4$var$$qa('.bubble').forEach((bubble)=>{
        bubble.classList.add('shown');
    });
    $388b617130f03bd4$var$typing(0, gen);
};
$388b617130f03bd4$var$collectSentences(document.documentElement.lang);
if ($388b617130f03bd4$var$container) $388b617130f03bd4$var$container.innerHTML = '';
setTimeout(()=>{
    $388b617130f03bd4$var$typing(0, $388b617130f03bd4$var$typingGen);
}, 2000);
const $388b617130f03bd4$var$typing = (i, gen)=>{
    if (gen !== $388b617130f03bd4$var$typingGen || !$388b617130f03bd4$var$container) return;
    if (!$388b617130f03bd4$var$sentences[i]) {
        $388b617130f03bd4$var$$qa('.bubble').forEach((bubble)=>{
            bubble.classList.remove('shown');
        });
        return;
    }
    const sentence = $388b617130f03bd4$var$sentences[i];
    const text = sentence.text + '_';
    $388b617130f03bd4$var$forward(text, 0, ()=>{
        $388b617130f03bd4$var$typing(i + 1, gen);
    }, sentence.wait, sentence.back, gen);
};
const $388b617130f03bd4$var$forward = (text, x, done, wait, back, gen)=>{
    if (gen !== $388b617130f03bd4$var$typingGen || !$388b617130f03bd4$var$container) return;
    let blinking = '';
    const nextX = x + 1;
    if (nextX === text.length) blinking = 'bubble-blinking';
    const part = text.substring(0, nextX);
    const parts = '> ' + part.substring(0, nextX - 1) + '<span class="bubble-cursor ' + blinking + '">' + part.substring(nextX - 1, nextX) + '</span>';
    $388b617130f03bd4$var$container.innerHTML = parts;
    if (nextX < text.length) setTimeout(()=>{
        $388b617130f03bd4$var$forward(text, nextX, done, wait, back, gen);
    }, Math.random() * 70 + 10);
    else setTimeout(()=>{
        if (back) $388b617130f03bd4$var$backward(text, nextX, done, gen);
        else done();
    }, wait);
};
const $388b617130f03bd4$var$backward = (text, x, done, gen)=>{
    if (gen !== $388b617130f03bd4$var$typingGen || !$388b617130f03bd4$var$container) return;
    const nextX = x - 1;
    $388b617130f03bd4$var$container.innerHTML = '> ' + text.substring(0, nextX) + '<span class="bubble-cursor">_</span>';
    if (nextX !== 0) setTimeout(()=>{
        $388b617130f03bd4$var$backward(text, nextX, done, gen);
    }, Math.random() * 40);
    else done();
};
// ────────────────────────────────────────────────────────────────────────────
const $388b617130f03bd4$var$$cursor = document.querySelector('#cursor');
if ($388b617130f03bd4$var$$cursor) {
    let cursorX = 0;
    let cursorY = 0;
    let cursorFrame = null;
    let hoverState = false;
    let lastTouchAt = 0;
    const clearHover = ()=>{
        $388b617130f03bd4$var$$cursor.classList.remove('hover');
        hoverState = false;
    };
    const renderCursor = ()=>{
        $388b617130f03bd4$var$$cursor.style.left = `${cursorX}px`;
        $388b617130f03bd4$var$$cursor.style.top = `${cursorY}px`;
        const hovered = document.elementFromPoint(cursorX, cursorY);
        const isOverLink = !!(hovered && hovered.closest('a'));
        if (isOverLink !== hoverState) {
            $388b617130f03bd4$var$$cursor.classList.toggle('hover', isOverLink);
            hoverState = isOverLink;
        }
        cursorFrame = null;
    };
    window.addEventListener('mousemove', (e)=>{
        if (Date.now() - lastTouchAt < 500) return;
        cursorX = e.clientX;
        cursorY = e.clientY;
        if (!cursorFrame) cursorFrame = requestAnimationFrame(renderCursor);
    });
    [
        'touchstart',
        'touchend',
        'touchcancel'
    ].forEach((event)=>{
        window.addEventListener(event, ()=>{
            lastTouchAt = Date.now();
            clearHover();
        });
    });
    window.addEventListener('mouseleave', clearHover);
}


//# sourceMappingURL=jaysalvat.com.adccfc66.js.map
